const { useQuery } = require('react-query');
const { getLoggedinUser } = require('../api/auth');

const useUser = () => {
  const { data, isLoading, isError, error } = useQuery(
    'user',
    getLoggedinUser,
    { retry: false, refetchOnWindowFocus: false }
  );
  return { user: data, isLoading, isError, error };
};
export default useUser;
